exports.list = {
    path: '/laporan_penerimaan_piutang',
    name: 'laporan_penerimaan_piutang', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_penerimaan_piutang/List.vue"),
  }
  